import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigBottom, createReturnReasonConfigShoes, createReturnReasonConfigTop } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Axel - jeans blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Mid Blue / Dark Blue",
                        },
                        {
                            type: "Size",
                            value: "24",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Axel - jeans blue.png",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Mid Blue / Dark Blue",
                        },
                        {
                            type: "Size",
                            value: "28",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Axel - jeans blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Color",
                            value: "Mid Blue / Dark Blue",
                        },
                        {
                            type: "Size",
                            value: "30",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Axel - jeans blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Mid Blue / Dark Blue",
                        },
                        {
                            type: "Size",
                            value: "32",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Axel - shoe green.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Green",
                        },
                        {
                            type: "Size",
                            value: "37",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Axel - shoe green.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Green",
                        },
                        {
                            type: "Size",
                            value: "39",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Axel - shoe green.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Green",
                        },
                        {
                            type: "Size",
                            value: "40",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Axel - shoe black.png",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "37",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Axel - shoe black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "38",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Axel - shoe black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "39",
                        },
                    ],
                },
            ],
        };
    }

    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Axel - T-shirt green.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Jolly Green",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Axel - T-shirt green.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Jolly Green",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Axel - T-shirt green.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Jolly Green",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Axel - T-shirt black.png",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Axel - T-shirt black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Axel - T-shirt black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
            ],
        };
    }

    return {
        exchangeAlternatives: [
            {
                id: "1",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "2",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                id: "3",
                inventoryMerchant: 0,
                inventoryTurnr: 1,
                inventoryTotal: 1,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
        ],
    };
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        pickupDateSelectionAllowed: true,
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "Hybrid Jeans",
                imageSrc: "/mocks/Axel - jeans blue.png",
                imageAlt: "/mocks/Axel - jeans blue.png",
                quantity: 1,
                purchasePrice: 1850,
                properties: [
                    {
                        type: "Size",
                        value: "26",
                    },
                    {
                        type: "Color",
                        value: "Mid Blue/Dark Blue",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigBottom(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "Dice Lo Sneaker",
                imageSrc: "/mocks/Axel - shoe green.png",
                imageAlt: "/mocks/Axel - shoe green.png",
                quantity: 1,
                purchasePrice: 2100,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                    },
                    {
                        type: "Size",
                        value: "38",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigShoes(),
            },
            {
                productVariantId: 30,
                sessionItemId: 3,
                productName: "Formula Oversized T-shirt",
                imageSrc: "/mocks/Axel - T-shirt green.png",
                imageAlt: "/mocks/Axel - T-shirt green.png",
                quantity: 1,
                purchasePrice: 1200,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Jolly Green",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
        ],
    };
}
